// Symboles partagés par TradingAccountsPage et la card extraite.
//
// Ils vivaient dans TradingAccountsPage, mais AccountCard les y importait alors
// que la page importe AccountCard : un CYCLE. Il tenait uniquement parce que ces
// symboles ne sont lus qu'au rendu ; une seule lecture au niveau module aurait
// fait échouer l'import (zone morte temporelle du `const` STATUS_STYLES).
// Ce module neutre casse le cycle : personne ne réimporte la page.

import useTranslation from "../client/hooks/useTranslation";
import type { AccountStatus, PropFirmTemplateSnapshot } from "./accountTypes";

export function formatCurrency(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
}

// ─── PropFirm Badge ───────────────────────────────────────────────────────────

export function PropFirmBadge({
  template,
  inherited,
  size = "sm",
}: {
  template: PropFirmTemplateSnapshot;
  inherited?: boolean;
  size?: "sm" | "xs";
}) {
  const t = useTranslation();
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 rounded-full font-medium ${size === "xs" ? "py-0 text-[10px]" : "py-0.5 text-xs"}`}
      style={{ backgroundColor: template.color, color: template.textColor }}
      title={inherited ? t.tradingAccounts.inheritedFromGroup : undefined}
    >
      {template.name}
      {inherited && <span className="opacity-70 text-[10px]">↑</span>}
    </span>
  );
}

export const STATUS_STYLES: Record<AccountStatus, { dot: string; label: string }> = {
  challenge: { dot: "bg-amber-400", label: "text-amber-600 dark:text-amber-400" },
  pa:        { dot: "bg-emerald-400", label: "text-emerald-600 dark:text-emerald-400" },
  live:      { dot: "bg-emerald-400", label: "text-emerald-600 dark:text-emerald-400" },
  demo:      { dot: "bg-blue-400", label: "text-blue-600 dark:text-blue-400" },
  inactive:  { dot: "bg-muted-foreground/40", label: "text-muted-foreground" },
};
